<template>
  <div>
    <v-row
      justify="center"
      style="box-shadow: 0 11px 15px -7px rgba(0, 0, 0, 1),
    0 24px 38px 3px rgba(0, 0, 0, 1), 0 9px 46px 8px rgba(0, 0, 0, 1) !important;"
    >
      <v-dialog
        :hide-overlay="false"
        v-model="open"
        persistent
        max-width="400px"
        style="box-shadow: 0 11px 15px -7px rgba(0, 0, 0, 1),
    0 24px 38px 3px rgba(0, 0, 0, 1), 0 9px 46px 8px rgba(0, 0, 0, 1) !important;"
      >
        <v-card>
          <v-card-title class="centraliza">
            <span class="headline" v-if="cliente.BLOQUEADO">Bloquear liberação de arquivos</span>
            <span class="headline" v-else>Desbloquear liberação de arquivos</span>
          </v-card-title>
          <v-container>
            <div class="centraliza" style="flex-wrap: wrap">
              <v-textarea
                v-if="cliente.BLOQUEADO"
                counter="255"
                name="input-6-1"
                label="Motivo do bloqueio"
                v-model="motivo"
              ></v-textarea>

              <md-field>
                <label for="password">Senha</label>
                <md-input
                  id="password"
                  v-on:keyup.enter="validate()"
                  name="password"
                  v-model="senha"
                  type="password"
                ></md-input>
              </md-field>
              <span
                v-if="!cliente.BLOQUEADO"
              >Ultimo bloqueio feito em {{databloqueio | formatDateNormal}}, pelo usuário: {{usuario}}</span>
            </div>
          </v-container>
          <v-card-actions class="centraliza">
            <v-btn color="#2A5377" style="color: #fff" text @click="$emit('cancel')">Cancelar</v-btn>
            <v-btn
              :loading="loading4"
              :disabled="loading4"
              color="#2A5377"
              v-if="cliente.BLOQUEADO"
              style="color: #fff"
              text
              @click="validate()"
            >
              Bloquear
              <v-icon right dark>mdi-cloud-upload</v-icon>
            </v-btn>
            <v-btn
              :loading="loading4"
              :disabled="loading4"
              color="#2A5377"
              v-else
              style="color: #fff"
              text
              @click="desbloqueio()"
            >
              Desbloquear
              <v-icon right dark>mdi-cloud-upload</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>
<script>
import * as ClientesService from "../../providers/clientes.service";
import * as LoginService from "../../providers/login.service";

import store from '@/store/index.js'

const md5 = require("MD5");
export default {
  props: ["open", "cliente"],
  data: () => ({
    usuario: "",
    motivo: "",
    databloqueio: "",
    dialog: true,
    loading4: false,
    senha: "",
    url: process.env.VUE_APP_API_URL + "/emsweb/userlogin"
  }),
  mounted() {
    this.usuario = this.cliente.USUARIOBLOQUEIO;
    this.motivo = this.cliente.MOTIVO;
    this.databloqueio = this.cliente.DATABLOQUEIO;
  },
  methods: {
    desbloqueio() {
      var self = this;
      self.loading4 = true;
      if (!self.senha) {
        alert("você deve informar uma senha");
        return;
      }
      var user = JSON.parse(localStorage.getItem("user"));
      store.dispatch("setUserData", user);

      LoginService.login({
        login: user.USULOGIN,
        password: md5(self.senha)
      })
        .then(r => {
          if (r.success) {
            ClientesService.changeDesbloqueiocliente({
              CLICODIGO: self.cliente.CLICODIGO
            })
              .then(r => {
                self.senha = "";
                self.motivo = "";
                self.$emit("success");
                self.loading4 = false;
              })
              .catch(err => {
                self.senha = "";
                self.motivo = "";
                self.$emit("cancel");
                self.loading4 = false;
              });
          } else {
            self.senha = "";
            self.motivo = "";
            self.$emit("cancel", r.Message);
            self.loading4 = false;
          }
        })
        .catch(e => {
          self.senha = "";
          self.motivo = "";
          self.$emit("cancel", e);
          self.loading4 = false;
        });
    },
    validate() {
      var self = this;
      self.loading4 = true;
      if (!self.senha) {
        alert("você deve informar uma senha");
        return;
      }
      var user = JSON.parse(localStorage.getItem("user"));
      store.dispatch("setUserData", user);

      LoginService.login({
        login: user.USULOGIN,
        password: md5(self.senha)
      })
        .then(r => {
          if (r.success) {
            ClientesService.changeBloqueiocliente({
              CLICODIGO: self.cliente.CLICODIGO,
              BLOQUEADO: self.cliente.BLOQUEADO,
              MOTIVO: self.motivo,
              USUARIOBLOQUEIO: user.USUNOME
            })
              .then(r => {
                self.senha = "";
                self.motivo = "";
                self.$emit("success");
                self.loading4 = false;
              })
              .catch(err => {
                self.senha = "";
                self.motivo = "";
                self.$emit("cancel");
                self.loading4 = false;
              });
          } else {
            self.senha = "";
            self.motivo = "";
            self.$emit("cancel", r.Message);
            self.loading4 = false;
          }
        })
        .catch(e => {
          self.senha = "";
          self.motivo = "";
          self.$emit("cancel", e);
          self.loading4 = false;
        });
    }
  }
};
</script>
<style >
.v-dialog {
  -webkit-box-shadow: 0 11px 15px -7px rgba(0, 0, 0, 0.2),
    0 24px 38px 3px rgba(0, 0, 0, 0.14), 0 9px 46px 8px rgba(0, 0, 0, 0.12) !important;
  box-shadow: 0 11px 15px -7px rgba(0, 0, 0, 0.2),
    0 24px 38px 3px rgba(0, 0, 0, 0.14), 0 9px 46px 8px rgba(0, 0, 0, 0.12) !important;
  border-radius: 8px !important;
  margin: 24px !important;
  overflow-y: auto;
  pointer-events: auto;
  -webkit-transition: 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  width: 100%;
  z-index: inherit !important;
}
.centraliza {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}
</style>